export default __webpack_public_path__ + "static/TEFL Iberia brochure web-de8a765c662caebe0399f272c0c7bac4.pdf";